export default __webpack_public_path__ + "static/founders-grotesk-light-604f2f32a9312f67e5efd9379ebe3aba.woff";